import { render, staticRenderFns } from "./SelectProductByType.vue?vue&type=template&id=4588f60e&"
import script from "./SelectProductByType.vue?vue&type=script&lang=ts&"
export * from "./SelectProductByType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4588f60e')) {
      api.createRecord('4588f60e', component.options)
    } else {
      api.reload('4588f60e', component.options)
    }
    module.hot.accept("./SelectProductByType.vue?vue&type=template&id=4588f60e&", function () {
      api.rerender('4588f60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GoodsReceiptChecklist/SelectProductByType.vue"
export default component.exports